import axios, { type AxiosInstance } from "axios";
import { firebaseAuth } from "../firebase";
import { FASTAPI_SERVER_URL } from "../constants/aws-constants";

/**
 * Axios instance that attaches the current user's Firebase ID token to
 * every outgoing request as `Authorization: Bearer <token>`. The backend
 * dependencies `get_org_id_flexible` / `get_org_id_from_firebase_token`
 * then derive the `organisationId` from the token's custom claims, so
 * callers no longer need to pass `organisationId` explicitly.
 */
const apiClient: AxiosInstance = axios.create({
  baseURL: FASTAPI_SERVER_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const user = firebaseAuth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
